module.exports = __webpack_public_path__ + "img/banner3_4_th.0bd54559.png";